import { ref } from 'vue';
import { acquireApiToken, getActiveAccount } from '@/auth/msalConfig';
export function useMe() {
    const me = ref(null);
    async function fetchMe() {
        const account = getActiveAccount();
        if (!account)
            return null;
        const token = await acquireApiToken(account);
        if (!token)
            return null;
        // /v1/me is not yet in the generated OpenAPI schema (regenerate once B1
        // types land in the codegen pipeline); use direct fetch in the meantime.
        const baseUrl = import.meta.env.VITE_API_BASE_URL ?? import.meta.env.VITE_API_PROD_URL ?? '';
        const res = await fetch(`${baseUrl}/v1/me`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) {
            me.value = null;
            return null;
        }
        const dto = (await res.json());
        me.value = dto;
        return dto;
    }
    return { me, fetchMe };
}
